import u from "./_common.js";
import x from "../../_styles/common/light.js";
function m(d) {
  const {
    textColor2: o,
    closeIconColor: r,
    closeIconColorHover: e,
    closeIconColorPressed: s,
    infoColor: g,
    successColor: t,
    errorColor: I,
    warningColor: S,
    popoverColor: l,
    boxShadow2: c,
    primaryColor: i,
    lineHeight: f,
    borderRadius: a,
    closeColorHover: n,
    closeColorPressed: C
  } = d;
  return Object.assign(Object.assign({}, u), {
    closeBorderRadius: a,
    textColor: o,
    textColorInfo: o,
    textColorSuccess: o,
    textColorError: o,
    textColorWarning: o,
    textColorLoading: o,
    color: l,
    colorInfo: l,
    colorSuccess: l,
    colorError: l,
    colorWarning: l,
    colorLoading: l,
    boxShadow: c,
    boxShadowInfo: c,
    boxShadowSuccess: c,
    boxShadowError: c,
    boxShadowWarning: c,
    boxShadowLoading: c,
    iconColor: o,
    iconColorInfo: g,
    iconColorSuccess: t,
    iconColorWarning: S,
    iconColorError: I,
    iconColorLoading: i,
    closeColorHover: n,
    closeColorPressed: C,
    closeIconColor: r,
    closeIconColorHover: e,
    closeIconColorPressed: s,
    closeColorHoverInfo: n,
    closeColorPressedInfo: C,
    closeIconColorInfo: r,
    closeIconColorHoverInfo: e,
    closeIconColorPressedInfo: s,
    closeColorHoverSuccess: n,
    closeColorPressedSuccess: C,
    closeIconColorSuccess: r,
    closeIconColorHoverSuccess: e,
    closeIconColorPressedSuccess: s,
    closeColorHoverError: n,
    closeColorPressedError: C,
    closeIconColorError: r,
    closeIconColorHoverError: e,
    closeIconColorPressedError: s,
    closeColorHoverWarning: n,
    closeColorPressedWarning: C,
    closeIconColorWarning: r,
    closeIconColorHoverWarning: e,
    closeIconColorPressedWarning: s,
    closeColorHoverLoading: n,
    closeColorPressedLoading: C,
    closeIconColorLoading: r,
    closeIconColorHoverLoading: e,
    closeIconColorPressedLoading: s,
    loadingColor: i,
    lineHeight: f,
    borderRadius: a
  });
}
const v = {
  name: "Message",
  common: x,
  self: m
}, P = v;
export {
  P as default,
  m as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/styles/light.js
// module id = 1718
// module chunks = 67